<template>
  <div class="register-change-password-form">
    <div class="heading">
        <bf-row type="flex" class="mb-s" align="middle" justify="space-between">
          <h3>{{ $t('title.changePassword') }}</h3>
          <bf-link underline="">
            <a
              class="text-gray text-decoration"
              href="#skipStep"
              @click.prevent="skipStep"
            >{{ $t("common.skipStep") }}</a>
          </bf-link>
        </bf-row>
        <div class="line-height-s">
          <strong><span class="text-red">*</span> {{$t("common.note")}}: </strong>
          <i18n
            path="title.changePasswordSubtitle"
            tag="span"
          >
            <strong place="time">{{ pasExpirTime }}</strong>
          </i18n>
        </div>
    </div> <!-- /.heading -->
    <ChangePasswordForm :count="count" :isLoading="isLoading" @submit="handleSubmit"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import userServices from '@/services/user';

const ChangePasswordForm = () => import('@/components/forms/ChangePasswordForm');

export default {
  name: 'ChangePassword',
  props: {
    password: {
      type: String,
      default: '',
    },
    count: {
      type: Number,
      default: 0,
    },
  },
  components: {
    ChangePasswordForm,
  },
  data() {
    return {
      isLoading: false,
      pasExpirTime: '48h',
      formName: 'ChangePassword',
    };
  },
  computed: {
    ...mapGetters('device', [
      'isMobile',
    ]),
  },
  beforeMount() {
    if (this.password === '') {
      this.$emit('goToStep', 'step-2');
    }
  },
  methods: {
    async handleSubmit(data) {
      const dataObject = {
        event: 'changepassword',
        category: 'click',
        label: 'label_changepassword',
      };
      if (typeof dataLayer !== 'undefined') {
        dataLayer.push(dataObject);
      }
      try {
        this.isLoading = true;
        const payload = {
          new_password: data.newPassword,
          old_password: this.password,
        };
        const response = await userServices.updatePassword(payload);
        this.$notify({
          title: this.$t('notification.success.title'),
          message: response?.message,
          type: 'success',
          customClass: 'success',
        });
        this.isLoading = false;
        this.$emit('goToStep', 'final-step');
      } finally {
        this.isLoading = false;
      }
    },
    skipStep() {
      this.$emit('goToStep', 'final-step');
    },
  },
};
</script>
